import { defineSelectorFactory } from '@exodus/redux-dependency-injection';
import { createSelector } from 'reselect';
const allNonCustodialSelectorFactory = (namesSelector, isCustodialSelector) => createSelector(namesSelector, isCustodialSelector, (allWalletAccounts, isCustodialWallet) => allWalletAccounts.filter((walletAccount) => !isCustodialWallet(walletAccount)));
const allNonCustodialSelectorDefinition = defineSelectorFactory({
    id: 'allNonCustodial',
    selectorFactory: allNonCustodialSelectorFactory,
    dependencies: [
        { selector: 'names' },
        { selector: 'isCustodial' },
    ],
});
export default allNonCustodialSelectorDefinition;
